/** Rename a chat from its row menu: the search hub and the wall's Chats pin. */
import type { DurableConversation } from "@/api/conversations";
import { InputDialog } from "@/components/ui";
import { useT } from "@/i18n";
import { panelsSearchMessages } from "@/i18n/messages/panels-search";
import { conversationDisplayName } from "@/lib/conversation-display";

export function ChatRenameDialog({
  chat,
  onRename,
  onClose,
}: {
  chat: DurableConversation;
  onRename: (chat: DurableConversation, name: string) => Promise<void>;
  onClose: () => void;
}) {
  const t = useT(panelsSearchMessages);
  return (
    <InputDialog
      title={t("renameChat")}
      inputLabel={t("chatName")}
      initialValue={conversationDisplayName({
        title: chat.title,
        display_title: chat.display_title,
      })}
      maxLength={500}
      errorMessage={t("renameFailed")}
      onCancel={onClose}
      onSubmit={async (name) => {
        await onRename(chat, name);
        onClose();
      }}
      data-testid="hub-chat-rename"
    />
  );
}
